import { render } from "./basicExample.vue?vue&type=template&id=11878ea4"
import script from "./basicExample.vue?vue&type=script&lang=js"
export * from "./basicExample.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__